import { useMutation } from '@tanstack/react-query'

import { GET_PROJECTS_QUERY } from '@/hooks/queries/use-get-projects'
import { useCompanies } from '@/hooks/use-companies'
import { queryClient } from '@/services/query-client'
import { updateProjectShare } from '@/services/update-project-share'

interface UseUpdateProjectSharePayload {
  project: { private: boolean; id: number; name: string }
  users: { id: number; name: string; email: string }[]
}

export const useUpdateProjectShare = () => {
  const { selectedCompany } = useCompanies()

  const mutation = useMutation({
    mutationFn: ({ project, users }: UseUpdateProjectSharePayload) =>
      updateProjectShare({
        project: { ...project, company_id: selectedCompany.id },
        users,
      }),

    onSuccess: () => {
      queryClient.invalidateQueries([GET_PROJECTS_QUERY])
    },
  })

  return mutation
}
